import React from 'react';
import { DisplayMode } from '../../RenderForm';
import { TextfieldDisabledWrapper, ViewWrapper } from '../common/questionWrappers';
export const ViewLongText = ({
  value,
  displayMode
}) => {
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    return /*#__PURE__*/React.createElement(TextfieldDisabledWrapper, null, /*#__PURE__*/React.createElement("div", null, value));
  }
  return /*#__PURE__*/React.createElement(ViewWrapper, null, value);
};